import { Fragment, useContext, useEffect, useRef, useState } from "react";
import MyFavoriteListSkeleton from "../../../../Skeleton/myFavouriteView/myFavouriteListSkeleton";
import $ from "jquery";
import "select2";
import { AddItemByCode } from "./addItemByCode";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { downloadJson2Excel, isValidArray } from "../../../../Layout/Common/common";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { ProductCardList } from "./productCardList";
import { ProductGridView } from "./productGridView";
import { AddItemByExcelUpload } from "./addItemByExcelUpload";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useNoteAlert } from "../../../../Context/pleaseNote";
import { BacktoPrevious } from "../../backtoPrevious";
import { ProductCardSkeleton } from "../../../../Skeleton/productCardSkeleton";
import { useFlashLoaderLoader } from "../../../../Context/FlashScreenContext";
import { useAuth } from "../../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { showCartToast } from "../../../../utils/cartToastManager";

export const MyFavoriteListEdit = ({ listId }) => {
  const [itemList, setItemList] = useState(null);
  const [listDetail, setListDetail] = useState(null);
  const [productView, setProductView] = useState("grid");
  const [addbycodeClicked, setAddbycodeClicked] = useState(false);
  const [addbyExcelClicked, setAddbyExcelClicked] = useState(false);
  const selectRef = useRef();
  const { getFavouriteListDetails, handleAddtoCart, addToCardQuickOrder } = useGlobalFunction();
  const { WishList } = useContext(GlobalContext);
  const { showFlashScreen, showRestrictionAlert } = useNoteAlert();
  const [productListDetail, setproductListDetail] = useState(null);
  const { showLoader, hideLoader } = useFlashLoaderLoader();
  const globalcontext = useContext(GlobalContext);
  const histroy = useNavigate();
  const { userId, companyId, role } = useAuth();
  useEffect(() => {
    if (listId) {
      getListDetails(listId);
    } else {
      setListDetail(null);
      setItemList(null);
    }
  }, [listId, WishList]);
  const getListDetails = async () => {
    var response = await getFavouriteListDetails(listId);
    if (response) {
      if (response.listDetails) setListDetail(response.listDetails);
      else {
        showRestrictionAlert({
          content: `<p class="text-center col-fs-14 fs-15 fw-normal">Invalid Favorite Product List ID.</p>`,
          title: "Restricted Area",
          showCloseBtn: true,
          icon: "wes-address-home",
          crossButton: false,
          closeBtnFunction: () => {
            histroy("/myaccount");
          },
        });
      }
      if (response.itemList) {
        setItemList(response.itemList);
        //const productIds = response.itemList.map(product => ({
        //    productId: product.productId,
        //    quantity: 1
        //}));
        //const productIds = response.itemList.map(p => p.productId);
        const uniqueProducts = Object.values(
          response.itemList.reduce((acc, item) => {
            acc[item.productCode] = item; // overrides older one
            return acc;
          }, {}),
        );
        const productIds = uniqueProducts.map((p) => p.productCode);

        setproductListDetail(productIds);
      }
    }
  };
  const handleAddtocartClick = async (event) => {
    if (productListDetail?.length) {
      showLoader();
      showFlashScreen(true);
      const data = productListDetail.map((sku) => ({
        sku: sku,
        qty: 1,
      }));
      var response = await addToCardQuickOrder({
        userId: userId,
        itemList: data,
      });
      if (response && response.data) {
        globalcontext.setCartItem(response.data);
        const bPids = new Set(data.map((obj) => obj.sku));
        const cartItem = response.data.cartItem;
        const productData = cartItem.filter((obj) => bPids.has(obj.prod_code));
        if (productData) showCartToast(productData);
      }
      hideLoader();
      showFlashScreen(false);
    }
  };
  useEffect(() => {
    if (listDetail) {
      $(selectRef.current).select2({
        placeholder: `<span class="favProductIcon"><span class="wes-add-pros"></span>Add Products</span>`,
        escapeMarkup: (m) => m,
        minimumResultsForSearch: Infinity,
      });
      $(selectRef.current).on("select2:select", function (e) {
        const selectedValue = e.target.value;

        if (selectedValue == "modalOrderCode") {
          setAddbycodeClicked(true);
        } else if (selectedValue == "modalOrderExcel") {
          setAddbyExcelClicked(true);
        }
      });
      return () => {
        $(selectRef.current).select2("destroy");
      };
    } else {
    }
  }, [listDetail]);

  const handleDownloadClick = () => {
    try {
      showFlashScreen(true);
      var productCodeList = itemList.map(({ productCode }) => {
        return { Code: productCode };
      });
      downloadJson2Excel({
        jsonData: productCodeList,
        fileName: listDetail.listName,
      });
      showFlashScreen(false);
    } catch (e) {
      showFlashScreen(false);
      console.error(e);
    }
  };
  return (
    <Fragment>
      <div className="container-fluid container-lg">
        {listDetail ? (
          <Fragment>
            <div className="row">
              <div className="col-lg-12">
                <div className="favList-header br-y">
                  <div className="row">
                    <div className="col-md-12 col-lg-4">
                      <div className="pt-3 favListing-products">
                        <div className="favListing">
                          <p className="favListing-lft favListing-red">{String(listDetail.listName).charAt(0)}</p>
                          <div className="favListing-rht">
                            <h1>{listDetail.listName}</h1>
                            <ul>
                              <li>
                                <span>Item:</span>
                                {listDetail.productCount}
                              </li>
                              <li>
                                <i className="fa-solid fa-circle" />
                              </li>
                              <li>
                                <span>Created:</span>
                                {listDetail.createdDate}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-8">
                      <div className="favListing-sorting mt-2 mt-md-1 mt-lg-3">
                        <div className="favListing-prodList">
                          <div className="favListing-addProducts favListing-options">
                            <button
                              type="button"
                              className="btn btn-products btn-unavailable mb-0"
                              onClick={handleDownloadClick}
                              disabled={itemList ? false : true}
                            >
                              <span className="wes-download" />
                              <span className="favDownloadAll">Download All</span>
                            </button>
                          </div>
                          <div className="favListing-addProducts favListing-options">
                            <button
                              type="submit"
                              className="btn btn-products add-all-items mb-0"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              data-bs-title="Add all items to cart"
                              disabled={!listDetail?.productCount}
                              onClick={handleAddtocartClick}
                            >
                              <span className="wes-add" />
                              <span className="favDownloadAll">Add all items to cart</span>
                            </button>
                          </div>

                          <div className="favListing-addSelect favListing-options">
                            <select
                              ref={selectRef}
                              id="favProductType"
                              className="js-states form-control"
                              value=""
                              style={{ width: "220px" }}
                            >
                              <option value="" disabled></option>
                              <option value="modalOrderCode">Add Item by Order Code</option>
                              <option value="modalOrderExcel">Add Item by Excel Upload</option>
                            </select>
                          </div>
                        </div>
                        <div className="sort-filters">
                          <div className="card-row">
                            <a
                              href="#"
                              onClick={() => {
                                setProductView("list");
                              }}
                              className={`row-products  ${productView == "list" ? "active" : ""}
                             `}
                            >
                              <span className="wes-row-filter" />
                            </a>
                            <a
                              href="#"
                              onClick={() => {
                                setProductView("grid");
                              }}
                              className={`grid-products  ${productView == "grid" ? "active" : ""}
                             `}
                            >
                              <span className="wes-card-filter" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <AddItemByCode
              show={addbycodeClicked}
              setShow={setAddbycodeClicked}
              listId={listId}
              updateList={getListDetails}
            />
            <AddItemByExcelUpload
              show={addbyExcelClicked}
              setShow={setAddbyExcelClicked}
              listId={listId}
              updateList={getListDetails}
            />
          </Fragment>
        ) : (
          <MyFavoriteListSkeleton />
        )}
        {isValidArray(itemList) && (
          <div className="row">
            <div className="col-lg-12">
              <div className="ct-filter-product">
                <div className="row row-spacing row-equal">
                  <TransitionGroup component={null}>
                    {itemList.map((row, index) => (
                      <CSSTransition key={row.productId} timeout={1000} classNames="card">
                        {productView == "grid" ? (
                          <ProductGridView data={row} index={index} updateList={getListDetails} />
                        ) : (
                          <ProductCardList data={row} index={index} updateList={getListDetails} />
                        )}
                      </CSSTransition>
                    ))}
                  </TransitionGroup>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};
